import $ from "jquery";
import config from "../../../config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { BiInfoCircle } from "react-icons/bi";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { millionComma } from "../../../utils";
import { useState } from "react";

const CHECKED = 1;

const Row = (props) => {
  const data = props.row;
  const index = props.index;
  const visible = props.cols;
  const navigate = useNavigate();

  const [openPopover, setOpenPopover] = useState({ row: null, col: null });

  const changeRecon = async (e) => {
    let is_recon = data?.is_recon == 1 ? 0 : 1;
    await $.post(
      `${config.apiUrl}/ledger/changeRecon`,
      JSON.stringify({ ledger_id: data?.ledger_id, is_recon: is_recon }),
    )
      .done((res) => {
        props.handler.getList();
      })
      .fail((err) => {
        Swal.fire("", err.responseJSON.message);
      });
  };

  const viewDetails = () => {
    const id = data?.trans_id || data?.tran_id;

    const typeKey = (data?.trans_type || data?.tran_type || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

    const path = {
      purchase: "/purchase/view/",
      "purchase return": "/purchase-return/view/",
      challan: "/challan/view/",
      "challan return": "/challanRtn/view/",
      expense: "/expense/view/",
      income: "/expense/view/",
      "stock out": "/stock-adjustment/view/",
      "stock in": "/stock-adjustment/view/",
    };

    // 🔹 Primary match (trans_type based)
    if (path[typeKey] && id) {
      window.open(config.baseUrl + path[typeKey] + id, "_blank", "noreferrer");
      return;
    }

    // 🔹 Fallbacks (old data / edge cases)
    if (data?.challan_id) {
      window.open(
        config.baseUrl + "/challan/view/" + data.challan_id,
        "_blank",
        "noreferrer",
      );
    } else if (data?.challan_rtn_id) {
      window.open(
        config.baseUrl + "/challanRtn/view/" + data.challan_rtn_id,
        "_blank",
        "noreferrer",
      );
    } else if (data?.po_id) {
      window.open(
        config.baseUrl + "/purchase/view/" + data.po_id,
        "_blank",
        "noreferrer",
      );
    } else if (data?.po_rtn_id) {
      window.open(
        config.baseUrl + "/purchase-return/view/" + data.po_rtn_id,
        "_blank",
        "noreferrer",
      );
    }
  };

  const renderTable = (modalData) => {
    try {
      let parsedData = JSON.parse(modalData);

      return (
        <>
          <table className="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Pay Mode</th>
                <th>Conversion Rate X Amount</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {parsedData.map((item, index) => (
                <tr key={index}>
                  <td>{item.mode}</td>
                  {item.mode === "USD" && Number(item.conv_amt) !== 0 ? (
                    <td className="text-end">
                      {millionComma(item.conv)} X {millionComma(item.conv_amt)}
                    </td>
                  ) : (
                    <td className="text-end">-</td>
                  )}
                  <td align="right">{millionComma(item.amt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      );
    } catch (err) {
      console.error(err);
    }
  };

  const goStockMoment = (col) => {
    let type = [
      { value: "1", col: "pur", label: "Purchase" },
      { value: "3", col: "pur_rtn", label: "Purchase Return" },
      { value: "2", col: "sales", label: "Challan" },
      { value: "4", col: "sales_rtn", label: "Challan Return" },
      { value: "6", col: "adjustment_in", label: "Stock In" },
      { value: "5", col: "adjustment_out", label: "Stock Out" },
    ];
    const matchedType = type.find((item) => item.col === col);

    const payload = {
      RowData: data,
      filter: props?.filter,
      TransType: matchedType,
    };

    // sessionStorage.setItem("stockMovementPayload", JSON.stringify(payload));
    // window.open(`${config.baseUrl}/stock/movement`, "_blank", "noreferrer");

    const queryParams = new URLSearchParams({
      RowData: encodeURIComponent(JSON.stringify(data)),
      filter: encodeURIComponent(JSON.stringify(props?.filter)),
      TransType: encodeURIComponent(JSON.stringify(matchedType)),
    }).toString();
    window.open(`/stock/movement?${queryParams}`, "_blank", "noreferrer");

    // navigate("/stock/movement", {
    //   state: { RowData: data, filter: props?.filter, TransType: matchedType },
    // });
  };
  return (
    <>
      <tr className={`${data?.is_active === 0 ? "text-danger" : ""}`}>
        {Object.keys(data).map((col, i) => (
          <>
            {visible.includes(col) && (
              <>
                {["is_recon"].includes(col) ? (
                  <>
                    <td>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="is_recon"
                          id="is_recon"
                          checked={data[col] == CHECKED}
                          onChange={(e) => changeRecon(e)}
                        />
                      </div>
                    </td>
                  </>
                ) : (
                  <td
                    className={
                      [
                        "op_stk",
                        "in_qty",
                        "out_qty",
                        "cl_stk",
                        "op_st",
                        "pur",
                        "sales",
                        "pur_rtn",
                        "sales_rtn",
                        "adjustment_in",
                        "adjustment_out",
                        "cl_st",
                        "chal_amt",
                        "exp_amt",
                        "inc_amt",
                        "trans_amount",
                        "qty",
                        "rate",
                        "amount",
                        "total_amount",
                        "chal_rtn_amt",
                        "challan_qty",
                        "wd_amt",
                        "cr_amount",
                        "dr_amount",
                        "return_amt",
                        "final_amt",
                      ].includes(col)
                        ? "text-end"
                        : ""
                    }
                  >
                    {[
                      "trans_type",
                      "tran_type",
                      "challan_id",
                      "challan_no",
                      "po_no",
                      "po_rtn_no",
                      "challan_rtn_no",
                      // "pur",
                      // "sales",
                      // "pur_rtn",
                      // "sales_rtn",
                      // "adjustment_in",
                      // "adjustment_out"
                    ].includes(col) ? (
                      <span
                        role="button"
                        className={`${
                          data[col] == "Opening" ||
                          data[col] == "Closing" ||
                          data[col] == "Cash Withdraw"
                            ? ""
                            : "fw-bold text-primary text-decoration-underline"
                        }`}
                        onClick={() => viewDetails()}
                      >
                        {data[col]}
                      </span>
                    ) : [
                        "pur",
                        "sales",
                        "pur_rtn",
                        "sales_rtn",
                        "adjustment_in",
                        "adjustment_out",
                      ].includes(col) ? (
                      <span
                        role="button"
                        className="fw-bold text-primary text-decoration-underline"
                        onClick={() => goStockMoment(col)}
                      >
                        {data[col]}
                      </span>
                    ) : (
                      <>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data[col] ?? 0,
                          }}
                        ></span>
                        {data[`${col}_modal`] && Number(data[col]) !== 0 && (
                          <OverlayTrigger
                            trigger="click"
                            placement="top"
                            overlay={
                              <Popover
                                style={{ maxWidth: "25rem", width: "25rem" }}
                              >
                                <Popover.Body>
                                  {renderTable(data[`${col}_modal`])}
                                </Popover.Body>
                              </Popover>
                            }
                            show={
                              openPopover.row == index &&
                              openPopover.col === col
                            }
                            onToggle={() => {
                              setOpenPopover(
                                openPopover.row == index &&
                                  openPopover.col === col
                                  ? { row: null, col: null }
                                  : { row: index, col: col },
                              );
                            }}
                          >
                            <span className="d-inline-block ms-1">
                              <BiInfoCircle role="button" size={16} />
                            </span>
                          </OverlayTrigger>
                        )}
                      </>
                    )}
                  </td>
                )}
              </>
            )}
          </>
        ))}
      </tr>
    </>
  );
};

export default Row;
